export const HeartIcon = () => {
  return (
    <svg width="40" height="40" viewBox="-2 -2 36 34">
      <path
        d="M23.6,0C20.4,0,17.9,2.1,16,5.1C14.1,2.1,11.6,0,8.4,0C3.8,0,0,3.8,0,8.4
           c0,4.5,3.4,8.2,8.5,13.1c2.4,2.2,5.1,4.4,7.5,6.5c2.4-2.1,5.1-4.3,7.5-6.5
           c5.1-4.9,8.5-8.6,8.5-13.1C32,3.8,28.2,0,23.6,0z"
        fill="#fff"
        stroke="#333"
        strokeWidth="0.5"
      />
    </svg>
  );
};